import { combineReducers } from "redux";

import bgKey from "./bgKey";
import itemZoom from "./itemZoom";

export default combineReducers({
  bgKey,
  itemZoom
});